import React from 'react';
import { makeClassName } from '@siteless/util';
import { IconPropsType } from '../util/types';

const ShareIcon = ({ className, ...rest }: IconPropsType) => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    {...rest}
    className={makeClassName('ShareIcon', className)}
  >
    <path
      d="M18,23H6c-1.7,0-3-1.3-3-3v-8c0-0.6,0.4-1,1-1s1,0.4,1,1v8c0,0.6,0.4,1,1,1h12c0.6,0,1-0.4,1-1v-8c0-0.6,0.4-1,1-1
	s1,0.4,1,1v8C21,21.7,19.7,23,18,23z"
    />
    <path
      d="M16,7c-0.3,0-0.5-0.1-0.7-0.3L12,3.4L8.7,6.7c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l4-4c0.4-0.4,1-0.4,1.4,0l4,4
	c0.4,0.4,0.4,1,0,1.4C16.5,6.9,16.3,7,16,7z"
    />
    <path d="M12,16c-0.6,0-1-0.4-1-1V2c0-0.6,0.4-1,1-1s1,0.4,1,1v13C13,15.6,12.6,16,12,16z" />
  </svg>
);

export default ShareIcon;
